const API_KEY = '31449444226ba6345698313fe055564a';
const BASE_URL = 'https://api.themoviedb.org/3';
const TREND_URL = `${BASE_URL}/trending/movie/week`;
const SEARCH_URL = `${BASE_URL}/search/movie`;
const ID_URL = `${BASE_URL}/movie/`;
const LANGUAGE = 'en';

export { API_KEY, BASE_URL, TREND_URL, SEARCH_URL, ID_URL, LANGUAGE };
